"use client";

import { getBaseUrl } from "@/lib/utils";
import { getQueryClient, trpc } from "@/trpc/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { HTTPHeaders } from "@trpc/client";
import { loggerLink, unstable_httpBatchStreamLink } from "@trpc/react-query";
import { useState } from "react";
import SuperJSON from "superjson";

export function TRPCReactProvider(props: { children: React.ReactNode }) {
  const queryClient = getQueryClient();

  const [trpcClient] = useState(() =>
    trpc.createClient({
      transformer: SuperJSON,
      links: [
        loggerLink({
          enabled: (op) =>
            process.env.NODE_ENV === "development" ||
            (op.direction === "down" && op.result instanceof Error),
        }),
        unstable_httpBatchStreamLink({
          url: new URL("/api/trpc", getBaseUrl()).toString(),
          headers() {
            const headers: HTTPHeaders = {
              "x-trpc-source": "nextjs-react",
            };
            return headers;
          },
        }),
      ],
    }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        {props.children}
      </trpc.Provider>
    </QueryClientProvider>
  );
}
